import React from 'react';
import { IonIcon } from '@ionic/react';
import { connect } from 'react-redux';
import Modal from '../../components/modal';
import { Title, NormalText, StrongText, SmallText } from '../../components/common';
import { withTranslation } from '../../lib/translate';
import './index.css';
import { checkmarkCircleOutline, informationCircleOutline, lockClosedOutline } from 'ionicons/icons';
import { getMilestoneRewardsInfo } from '../../store/actions';
import Slider, { Slide } from '../../components/slider';
import { getConfig } from '../../appConfig';

const RewardItem = ({ reward, id, __, index, nextRewardIndex }) => {
	const { earned } = reward
	return (
		<div className={`loyalty-reward milestone-reward pointer ${earned ? 'milestone-reward-earned' : ''}`} >
			<div style={{ display: 'flex', position: 'relative', borderRadius: 'var(--okx-box-radius)', overflow: 'hidden' }}>
				{getConfig().general.milestoneRewardImage && earned &&
					<img className='milestone-reward-image-placeholder' src={getConfig().general.milestoneRewardImage} />
				}
				<img className='milestone-reward-image' src={reward.reward.image} />

				<div className='loyalty-next-reward'>
					{!earned ?
						<>
							<IonIcon icon={lockClosedOutline} />
						</>
						:
						<IonIcon style={{ height: '25px', width: '25px' }} icon={checkmarkCircleOutline} />

					}

				</div>
			</div>

			<div className="loyalty-reward-name">
				<StrongText className="block">{reward.name}</StrongText>
				{earned ?
					<SmallText>{__('Awarded')}</SmallText>
					:
					<SmallText>{`${__('Unlocks at')} ${reward.stamps_required} ${reward.stamps_required == 1 ? __('point') : __('points')}`}</SmallText>

				}
			</div>
		</div>
	);
};
class MilestoneRewards extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			selectedReward: null,
			rewardInfoModalOpen: false,
		};

	}
	componentDidMount() {
		this.props.dispatch(getMilestoneRewardsInfo());
	}


	getMilestoneRewardsData = (rewards, balance) => {
		if (!Array.isArray(rewards) || rewards.length === 0) {
			return { rewards: [], nextRewardPoints: 0 };
		}

		const sorted = [...rewards].sort((a, b) => a.stamps_required - b.stamps_required);

		const lastThreshold = sorted[sorted.length - 1].stamps_required;
		let nextRewardIndex = 0

		if (balance >= lastThreshold) {
			const finalList = sorted.map((item, index) => {
				const prev = index === 0 ? 0 : sorted[index - 1].stamps_required;
				const segmentSize = item.stamps_required - prev;

				return {
					...item,
					percentageFilled: "100%",
					percentage: `${((segmentSize / lastThreshold) * 100).toFixed(2)}%`,
					earned: true,
				};
			});

			return {
				rewards: finalList,
				nextRewardPoints: 0
			};
		}

		let prevThreshold = 0;
		let foundNext = false;
		let nextRewardPoints = 0;

		const processed = sorted.map((item, index) => {
			const currentThreshold = item.stamps_required;
			const segmentSize = currentThreshold - prevThreshold;

			let filledPercent;
			if (balance >= currentThreshold) {
				filledPercent = 100;
			} else if (balance <= prevThreshold) {
				filledPercent = 0;
			} else {
				const inside = balance - prevThreshold;
				filledPercent = +(inside / segmentSize * 100).toFixed(2);
			}

			let nextReward = false;
			if (!foundNext && balance < currentThreshold) {
				nextRewardPoints = currentThreshold - balance;
				foundNext = true;
				nextRewardIndex = index


			}
			const percentageOfTotal = +((segmentSize / lastThreshold) * 100).toFixed(2);

			const earned = balance >= currentThreshold;

			prevThreshold = currentThreshold;

			return {
				...item,
				percentageFilled: `${Math.floor(filledPercent)}%`,
				percentage: `${percentageOfTotal}%`,
				earned,
				nextReward
			};
		});

		return {
			rewards: processed,
			nextRewardPoints,
			nextRewardIndex
		};
	};




	render() {
		const { __, lifetime_balance, milestoneInfo, showOnlyProgress } = this.props;
		const { rewardInfoModalOpen } = this.state;
		const { rewards, nextRewardPoints, nextRewardIndex } = this.getMilestoneRewardsData(this.props.rewards, lifetime_balance)

		return (
			<>
				{showOnlyProgress ? <>
					<div className='milestone-wrapper box-wrapper'>
						<div className='milestone-header'>
							<StrongText>{__('Loyalty rewards')}</StrongText>
							<div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>

								<StrongText className='primary-color'>{lifetime_balance == 1 ? `${lifetime_balance} ${__('point')}` : `${lifetime_balance} ${__('points')}`} </StrongText>
								<IonIcon
									className='text-color'
									style={{ cursor: 'pointer', height: '25px', width: '25px' }}
									onClick={() => {
										this.setState({ rewardInfoModalOpen: true });
									}}
									icon={informationCircleOutline}
								/>
							</div>
						</div>
						<div className='milestone-progress-wrapper'>
							{nextRewardPoints > 0 &&

								<div>
									<StrongText>{__('Next reward')}</StrongText>
									<StrongText>{`${nextRewardPoints} ${nextRewardPoints == 1 ? __('point away') : __('points away')}`}</StrongText>
								</div>
							}
							<div className='milestone-progress-bar'>{
								rewards.map((el, rewardIndex) => (
									<div key={`reward_${rewardIndex}`} data-percentagefilled={el.percentageFilled} style={{ width: el.percentage }}>
										<span style={{ width: el.percentageFilled }}></span>
									</div>
								))}</div>
						</div>
					</div>
				</> : <>
					<div className='milestone-wrapper box-wrapper'>
						<div className='milestone-header'>
							<StrongText>{__('Loyalty rewards')}</StrongText>
							<div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>

								<StrongText className='primary-color'>{lifetime_balance == 1 ? `${lifetime_balance} ${__('point')}` : `${lifetime_balance} ${__('points')}`} </StrongText>
								<IonIcon
									className='text-color'
									style={{ cursor: 'pointer', height: '25px', width: '25px' }}
									onClick={() => {
										this.setState({ rewardInfoModalOpen: true });
									}}
									icon={informationCircleOutline}
								/>
							</div>

						</div>
						<>

							<div className='milestone-progress-wrapper'>
								{nextRewardPoints > 0 &&

									<div>
										<StrongText>{__('Next reward')}</StrongText>
										<StrongText>{`${nextRewardPoints} ${nextRewardPoints == 1 ? __('point away') : __('points away')}`}</StrongText>
									</div>
								}

								<div className='milestone-progress-bar'>{
									rewards.map((el, rewardIndex) => (
										<div key={`reward_${rewardIndex}`} data-percentagefilled={el.percentageFilled} style={{ width: el.percentage }}>
											<span style={{ width: el.percentageFilled }}></span>
										</div>
									))}</div>
							</div>

							<div style={{ overflow: 'hidden', display: 'block' }} className={`loyalty-rewards-wrapper milestones-wrapper`}
							>

								<Slider
									settings={{
										slidesPerView: rewards.length == 1 ? 1 : 1.3,
										spaceBetween: 10,
										slidesOffsetBefore: 0,
										centeredSlides: false,
										loop: false,
										initialSlide: nextRewardIndex

									}}
								>
									{rewards.map((reward, index) => (
										<Slide className={`${rewards.length == 1 ? 'single-slide' : ''}`} >
											<RewardItem nextRewardIndex={nextRewardIndex} key={'rw-' + index} reward={reward} __={__} available_balance={lifetime_balance} index={index} />

										</Slide>
									))}
								</Slider>
							</div>
						</>
					</div>

				</>}
				<Modal
					className="loyalty-faq-modal"
					isOpen={rewardInfoModalOpen}
					onDidDismiss={() => {
						this.setState({ rewardInfoModalOpen: false });
					}}
				>
					<div className="lefted">
						<Title className='modal-title'>{__('Milestone Rewards')}</Title>
						<div dangerouslySetInnerHTML={{ __html: milestoneInfo }}></div>
					</div>{' '}
				</Modal>
			</>
		);
	}
}
const stateToProps = (state) => {
	const { profile, auth } = state.profile;

	return {
		vouchers: state.profile.vouchers || [],
		qr_code: state.profile.profile.qr_code,
		profile,
		auth,
		milestoneInfo: state.common.milestoneInfo,
	};
};

export default connect(stateToProps)(withTranslation(MilestoneRewards));
